import fb from '../../firebase';

export const GetDocService = (data) => fb.doGetDocument(data);
export const SetDocService = (data) => fb.doSetDocument(data);
export const RemoveDocService = (data) => fb.doRemoveDocument(data);




